import { useContext } from 'react';
import { RequestFormContext } from '@/contexts';

export const useRequestForm = () => {
	const requestFormContext = useContext(RequestFormContext);
	return requestFormContext;
};
